<template>
  <div v-if="itens.length > 0" class="table-responsive mt-3">
    <table class="table table-sm table-striped fs-sm">
      <thead>
        <tr>
          <th>Centro de Custo</th>
          <th>Item</th>
          <th>Data do Orçamento</th>
          <th class="text-center">Valor Total</th>
          <th class="text-center">Valor Faturado</th>
          <th class="text-center">Saldo</th>
          <th class="text-center">Preço Unitário</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in itens" :key="index">
          <td>{{ item.centroDeCusto }}</td>
          <td>{{ item.item }}</td>
          <td class="text-center">
            {{ dateTimeRmToDateBR(item.dataOrcamento) }}
          </td>
          <td class="text-center">
            {{ formatToCurrencyBr(item.quantidadeItemOriginal) }}
          </td>
          <td class="text-center">
            {{ formatToCurrencyBr(item.valorFaturado) }}
          </td>
          <td class="text-center">
            {{ formatToCurrencyBr(item.quantidadeItemSaldo) }}
          </td>
          <td class="text-center">
            {{ formatToCurrencyBr(item.valorOrcamento) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <p v-else class="text-center mt-3 mb-0">Nenhum item encontrado</p>
</template>

<script>
import { formatToCurrencyBr } from '@/utils/currency'
import { dateTimeRmToDateBR } from '@/utils/date'

export default {
  name: 'ItensContract',

  props: {
    itens: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dateTimeRmToDateBR,
      formatToCurrencyBr,
    }
  },
}
</script>
